<div #container class="widget-container">
    <router-outlet></router-outlet>
</div>
<app-preloader></app-preloader>
<app-modal [bodyElement]="bodyElement"></app-modal>
<app-dialog></app-dialog>